// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Partials
import { PartialsModule } from '../../partials/partials.module';
// Pages
import { CoreModule } from '../../../core/core.module';

import { MaterialModule } from '../../pages/material.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploaderComponent } from './file-uploader.component';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
// Perfect Scrollbar
// import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
	declarations: [
        FileUploaderComponent
	],
	exports: [
		MaterialModule,
        FileUploaderComponent,
        PartialsModule
		],
	imports: [
        PartialsModule,
        CoreModule,
        CommonModule,
        MaterialModule,
        TranslateModule.forChild(),
		// PerfectScrollbarModule,
		
		// ng-bootstrap modules
		NgbDropdownModule,
		// NgbTabsetModule,
		NgbTooltipModule
	],
	providers: []
})
export class FileUploaderModule {
}
